import React, { memo, useCallback } from 'react'
import { makeStyles, useTheme } from '@material-ui/styles'
import { Theme } from '@material-ui/core'
import Divider from '@material-ui/core/Divider'
import { useTranslation } from 'react-i18next'

import styles from '../styles'
import { Badge } from 'components'
import { EEntity, IUser, ICompany } from 'models'
import useMediaQuery from '@material-ui/core/useMediaQuery'

interface MenuContentProps {
	closeMenu: any
	userCompanies?: ICompany[]
	onClick?: any
	articleAuthor?: IUser
}

const useStyles = makeStyles(styles)

const MenuContent: React.FunctionComponent<MenuContentProps> = ({
	closeMenu,
	userCompanies,
	onClick,
	articleAuthor,
}) => {
	const classes = useStyles()
	const { t } = useTranslation()
	const handleClick = useCallback(
		(type: EEntity, data: any) => () => {
			onClick(type, data)
		},
		[onClick],
	)
	const theme: Theme = useTheme()
	const isSmDown: boolean = useMediaQuery(theme.breakpoints.down('sm'))
	return (
		<div
			tabIndex={0}
			role="button"
			onClick={closeMenu}
			onKeyDown={closeMenu}
			className={classes.sidebarContentContainer}
		>
			{isSmDown && (
				<>
					<div className={classes.sidebarHeader}>{t('Post as')}</div>
					<div style={{ margin: '16px -16px' }}>
						<Divider light />
					</div>
				</>
			)}

			<div
				className={classes.sidebarRow}
				onClick={handleClick(EEntity.person, articleAuthor)}
			>
				<Badge
					avatarOnly={true}
					type={EEntity.person}
					user={articleAuthor ? articleAuthor : undefined}
				/>
				<div>
					{(articleAuthor &&
						articleAuthor.profileCollection?.edges &&
						`${articleAuthor.profileCollection?.edges[0].node.firstName} ${articleAuthor.profileCollection?.edges[0].node.lastName}`) ||
						''}
				</div>
			</div>

			{userCompanies &&
				userCompanies?.map((company: ICompany) => {
					const { name } = company
					return (
						<div key={company.slug}>
							<div style={{ margin: '16px -16px' }}>
								<Divider light />
							</div>
							<div
								className={classes.sidebarRow}
								onClick={handleClick(EEntity.company, company)}
							>
								<Badge
									type={EEntity.company}
									avatarOnly={true}
									company={company}
								/>
								<div>{name}</div>
							</div>
						</div>
					)
				})}
		</div>
	)
}

export default memo(MenuContent)
